import React, { useState, useEffect, useRef } from 'react'
import "./ViewBudgetSurrender.css";
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import { ADD_CHALLAN_FAIL } from "../../RTK/Slices/ChallanSlice";
import {
    get_schemes,
    fetchDepartmentSurrenderBudgets,
    get_budget_surrender_by_id,
    approve_budget_surrender
} from '../../helper/Api';
import { toast } from 'react-toastify';
import CustomBreadcrumbs from '../Tools/Breadcumbs';
import { 
    FormControl, 
    InputLabel, 
    Select, 
    MenuItem,
    TextField,
    TextareaAutosize,
    Chip
} from "@mui/material";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Spinner from '../Tools/spinner';

export default function ViewBudgetSurrenderComponent() {
    const dispatch = useDispatch();
        const [open, setOpen] = useState(false)
        const { authData, financialYears } = useSelector((state) => state.authData);
        const [loading, setLoading] = useState(false)
        const { id } = useParams();
        const [schemes, set_schemes] = useState([]);
        const fy_list = financialYears.payload.fy_list;
        const [approvalFormdata, setApprovalFormdata] = useState({
            remark: "",
            l2_status: "",
            l3_status: "",
            batch_id: id
        })
        const approvalRef = useRef(null);
        const navigate = useNavigate();
        const handleClickOpen = (approvalStatus) => {
            approvalRef.current = approvalStatus;
            setOpen(true);
        };

        const handleClose = () => {
            setOpen(false);
        };
        const [formData, setFormData] = useState({
            id: '',
            department_level: '',
            order_no: '',
            order_date: '',
            order_value: '',
            attachment: [],
            department_Id: "",
            department_name: "",
            financial_id: '',
            financial_year: '',
            activity: [],
            scheme_id: '',
            l2_approval: null,
            l3_approval: null,
            created_by: authData && authData.status ? authData.user.id : null
        });
        const [showConfirm, setShowConfirm] = useState(false);
        const [fromSchemeDetails, setFromSchemeDetails] = useState({
            scheme_id: '',
            name: '',
            department: '',
            grant_code: '',
            type: '',
            monitoring_level: '',
            is_activity_active: '',
        });
        // handle formal formdata
        const handleChallanFormData = (e) => {
            const name = e.target.name;
            const value = e.target.value;
            setFormData({
                ...formData,
                [name]: value
            });
            
        }
        // handle from scheme details
        const handleSchemeChange = async (event) => {
            const selectedSchemeId = event.target.value;
            if (selectedSchemeId && fromSchemeDetails.scheme_id) {
                setShowConfirm(true);
                return
            }
            const selectedScheme = schemes.find(scheme => scheme.id === selectedSchemeId);
            setFromSchemeDetails({
                ...fromSchemeDetails,
                scheme_id: selectedScheme.id,
                scheme_name: selectedScheme.name,
                department_name: selectedScheme.department,
                grant_code: selectedScheme.grant_code,
                scheme_type: selectedScheme.type,
                monitoring_level: selectedScheme.monitoring_level,
                is_activity_active: selectedScheme.is_activity_active,
            });
            try {
                setLoading(true);
                let payload = {
                    fy_id: formData.financial_id,
                    scheme_id: event.target.value,
                    department_level: formData.department_level
                }
            }catch(error) {
                setLoading(false);
                toast.error("Something went wrong!", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        };

        const fetch_list = async (financial_id) => {
            setLoading(true);
            const schemes_list = await get_schemes({ department_id: authData.user.department_id, fy_id: financial_id });
            if (schemes_list.data.status) {
                set_schemes(schemes_list.data.schemes);
                await fetch_budget_surrender_details(id);
                setLoading(false);
            } else {
                setLoading(false);
                set_schemes([]);
            }
        }
        const budgetSurrenderDetails = useRef([]);
        const fetch_budget_surrender_details = async (id) => {
            try {
                let response = await get_budget_surrender_by_id(id);
                if(response.data.status) {
                    budgetSurrenderDetails.current = response.data.result;
                    // setFromSchemeDetails(schemes.find(e => Number(e.id) === Number(response.data.result[0].scheme_id)));
                }
            }catch(error) {
                toast.error("Something went wrong!", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        }
    
        useEffect(() => {
            fetch_list();
        }, []);
        const linksArray = [
            {
                href: "/budget-surrender",
                label: "Budget Surrender",
            }
        ];
        const handleDepartmentLevelChange = (e) => {
            setFormData((prev) => ({...prev, department_level: e.target.value}))
        }

        const handleApprovalAction = async (approvalValue) => {
            try {
                setLoading(true);
                let payload = { ...approvalFormdata};
                if(authData.user.user_type === 'l2') {
                    payload.l2_status = approvalValue
                }
                if(authData.user.user_type === 'l3') {
                    payload.l3_status = approvalValue
                }
                const res = await approve_budget_surrender(payload);
                if(res.data.status) {
                    setLoading(false);
                    toast.success(res.data.message, {
                        position: toast.POSITION.TOP_CENTER,
                    });
                    setOpen(false);
                    navigate('/budget-surrender-pending');
                }
            }catch(err) {
                setLoading(false);
                toast.error(err.response.data.message || err.response.data.error || err.message, {
                    position: toast.POSITION.TOP_CENTER,
                });
                setOpen(false);
            }
        }

        return (
            <>
            {loading && <div > <Spinner/> </div>}
                <div>
                    <div className="p-3">
                        <div className="row">
                            <div className="col-md-6">
                                <h4 style={{ color: "#28326f", margin: 0 }}>View Budget Surrender</h4>
                                <CustomBreadcrumbs linksArray={linksArray} title="View Budget Surrender" />
                            </div>
                            <div className="col-md-6">
                                <div
                                className="d-flex gap-2"
                                style={{ width: "auto", float: "right" }}
                                >
                                <Chip label={Number(budgetSurrenderDetails.current[0]?.l2_approval) === 1 ? 'L2 Approved' : budgetSurrenderDetails.current[0]?.l2_approval === null ? 'L2 Pending' : 'L2 Rejected'} color={Number(budgetSurrenderDetails.current[0]?.l2_approval) === 1 ? 'success' : budgetSurrenderDetails.current[0]?.l2_approval === null ? 'warning' : 'error'}  size="large" />
                                <Chip label={Number(budgetSurrenderDetails.current[0]?.l3_approval) === 1 ? 'L3 Approved' : budgetSurrenderDetails.current[0]?.l3_approval === null ? 'L3 Pending' : 'L3 Rejected'} color={Number(budgetSurrenderDetails.current[0]?.l3_approval) === 1 ? 'success' : budgetSurrenderDetails.current[0]?.l3_approval === null ? 'warning' : 'error'}  size="large" />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card p-3 mt-3">
                                    <div className="row">
                                        <div className='col-md-12 mb-3'>
                                            <label htmlFor="inputType">
                                                Department Tier <span className="text-danger">*</span>
                                            </label><br/>
                                            <div className="form-check form-check-inline">
                                                <input
                                                    type="radio"
                                                    id="T1"
                                                    name="reimbursement_payment_levels"
                                                    value="T1"
                                                    checked={budgetSurrenderDetails.current[0]?.department_level === 'T1'}
                                                    onChange={handleDepartmentLevelChange}
                                                    className="form-check-input"
                                                />
                                                <label className="form-check-label" htmlFor="T1">
                                                    T1
                                                </label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input
                                                    type="radio"
                                                    id="T2"
                                                    name="reimbursement_payment_levels"
                                                    value="T2"
                                                    checked={budgetSurrenderDetails.current[0]?.department_level === 'T2'}
                                                    onChange={handleDepartmentLevelChange}
                                                    className="form-check-input"
                                                />
                                                <label className="form-check-label" htmlFor="T2">
                                                    T2
                                                </label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input
                                                    type="radio"
                                                    id="T3"
                                                    name="reimbursement_payment_levels"
                                                    value="T3"
                                                    checked={budgetSurrenderDetails.current[0]?.department_level === 'T3'}
                                                    onChange={handleDepartmentLevelChange}
                                                    className="form-check-input"
                                                />
                                                <label className="form-check-label" htmlFor="T3">
                                                    T3
                                                </label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input
                                                    type="radio"
                                                    id="T4"
                                                    name="reimbursement_payment_levels"
                                                    value="T4"
                                                    checked={budgetSurrenderDetails.current[0]?.department_level === 'T4'}
                                                    onChange={handleDepartmentLevelChange}
                                                    className="form-check-input"
                                                />
                                                <label className="form-check-label" htmlFor="T4">
                                                    T4
                                                </label>
                                            </div>
                                        </div>
                                        <div className="bg-prime-20 d-flex justify-content-between align-items-center p-2 transition overflow-hidden mb-3">
                                            <span className="fs-14px white-space-nowrap overflow-x-hidden fw-600 fs-16px" style={{ width: "95%", fontStyle: "normal" }} >Scheme Details</span>
                                        </div>
                                        <div className='col-md-4 mb-3'>
                                            <FormControl fullWidth>
                                                <InputLabel id="demo-simple-select-label">Financial Year *</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={budgetSurrenderDetails.current[0]?.financial_year_id || ""}
                                                    label="Financial Year *"
                                                    name="financial_year"
                                                    readOnly={true}
                                                >
                                                    {fy_list.map((fy) => (
                                                        <MenuItem value={fy.id} key={fy.id}>
                                                            {fy.year}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <FormControl fullWidth>
                                                <InputLabel id="scheme-namelabel">Scheme</InputLabel>
                                                <Select
                                                    labelId="scheme-namelabel"
                                                    id="scheme-name-select"
                                                    value={budgetSurrenderDetails.current[0]?.scheme_id || ""}
                                                    label="Scheme"
                                                    name="scheme_id"
                                                    onChange={handleSchemeChange}
                                                    readOnly={true}
                                                >
                                                {schemes.map((scheme) => (
                                                    <MenuItem value={scheme.id} key={scheme.id}>
                                                    {scheme.code} | {scheme.name}
                                                    </MenuItem>
                                                ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <FormControl fullWidth>
                                                <TextField
                                                id="name"
                                                label="Scheme Name"
                                                variant="outlined"
                                                type="text"
                                                readOnly={true}
                                                value={schemes?.find(e => Number(e.id) === Number(budgetSurrenderDetails?.current[0]?.scheme_id))?.name}
                                                InputLabelProps={{ shrink: true }}
                                                required
                                                />
                                            </FormControl>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <FormControl fullWidth>
                                                <TextField
                                                id="name"
                                                label="Scheme Department Name"
                                                variant="outlined"
                                                type="text"
                                                readOnly={true}
                                                value={schemes?.find(e => Number(e.id) === Number(budgetSurrenderDetails?.current[0]?.scheme_id))?.department}
                                                InputLabelProps={{ shrink: true }}
                                                required
                                                />
                                            </FormControl>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <FormControl fullWidth>
                                                <TextField
                                                id="name"
                                                label="Scheme Grant Code"
                                                variant="outlined"
                                                type="text"
                                                readOnly={true}
                                                value={schemes?.find(e => Number(e.id) === Number(budgetSurrenderDetails?.current[0]?.scheme_id))?.grant_code}
                                                InputLabelProps={{ shrink: true }}
                                                required
                                                />
                                            </FormControl>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <FormControl fullWidth>
                                                <TextField
                                                id="name"
                                                label="Scheme Type"
                                                variant="outlined"
                                                type="text"
                                                readOnly={true}
                                                value={schemes?.find(e => Number(e.id) === Number(budgetSurrenderDetails?.current[0]?.scheme_id))?.type}
                                                InputLabelProps={{ shrink: true }}
                                                required
                                                />
                                            </FormControl>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <FormControl fullWidth>
                                                <TextField
                                                id="name"
                                                label="Budget Order No."
                                                variant="outlined"
                                                type="text"
                                                name="budget_surrender_order_no"
                                                onChange={handleChallanFormData}
                                                value={budgetSurrenderDetails.current[0]?.order_no || ""}
                                                InputLabelProps={{ shrink: true }}
                                                required
                                                />
                                            </FormControl>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <FormControl fullWidth>
                                                <TextField
                                                id="name"
                                                label="Budget Order Date"
                                                variant="outlined"
                                                type="date"
                                                name="budget_surrender_order_date"
                                                onChange={handleChallanFormData}
                                                value={budgetSurrenderDetails.current[0]?.order_date || ""}
                                                InputLabelProps={{ shrink: true }}
                                                required
                                                />
                                            </FormControl>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <FormControl fullWidth>
                                                <TextField
                                                id="name"
                                                label="Budget Order Value"
                                                variant="outlined"
                                                type="number"
                                                name="budget_surrender_order_value"
                                                value={budgetSurrenderDetails.current?.reduce((sum, item) => {
  return sum + (Number(item.order_value) || 0);
}, 0) || ""}
                                                readOnly={true}
                                                required
                                                />
                                            </FormControl>
                                        </div>
                                        <div className="bg-prime-20 d-flex justify-content-between align-items-center p-2 transition overflow-hidden mb-3">
                                            <span className="fs-14px white-space-nowrap overflow-x-hidden fw-600 fs-16px" style={{ width: "95%", fontStyle: "normal" }} >Budget Selection</span>
                                        </div>
                                        
                                        <div className='col-md-12'>
                                            <table className="table table-responsive surrender-table">
                                                <thead>
                                                    <tr>
                                                        {/* <th style={{width: '5%', backgroundColor: '#28326f'}}>#</th> */}
                                                        <th>Department Name</th>
                                                        <th>Scheme Name</th>
                                                        <th>Subhead Name</th>
                                                        <th>Budget Available</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        budgetSurrenderDetails.current?.map((departmentRecord, index) => 
                                                            departmentRecord?.subheads?.map((subhead, subheadIndex) => (
                                                                <React.Fragment key={`${index}-${subheadIndex}`}>
                                                                <tr style={{borderTop: '2px solid #000'}}>
                                                                    
                                                                    <td>{ departmentRecord?.department_name}</td>
                                                                    <td>{fromSchemeDetails?.name}</td>
                                                                    <td>{subhead?.name}</td>
                                                                    <td><strong>{subhead?.amount}</strong></td>
                                                                </tr>
                                                                {
                                                                    subhead?.activities?.length > 0 && subhead?.activities.map((activity, activityIndex) => (
                                                                        <React.Fragment key={`${index}-${subheadIndex}-act-${activityIndex}`}>
                                                                            {
                                                                                activityIndex === 0 && <tr>
                                                                            <td style={{backgroundColor: "#dff0ff"}}></td>
                                                                            <td style={{backgroundColor: "#dff0ff"}}><strong>Activity</strong></td>
                                                                            <td style={{backgroundColor: "#dff0ff"}}><strong>Subactivity</strong></td>
                                                                            <td style={{backgroundColor: "#dff0ff"}}></td>
                                                                        </tr>
                                                                            }
                                                                            <tr>
                                                                                <td></td>
                                                                                <td>{activity.activity}</td>
                                                                                <td>{activity.subactivity}</td>
                                                                                <td>{activity.amount}</td>
                                                                            </tr>
                                                                        </React.Fragment>
                                                                    ))
                                                                }
                                                                </React.Fragment>
                                                            ))
                                                        )
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                        
                                        {
                                            
                                            ((authData.user.user_type === 'l2' || authData.user.user_type === 'l3') && ((authData.user.user_type === 'l2' && !budgetSurrenderDetails.current[0]?.l2_approval) || (authData.user.user_type === 'l3' && !budgetSurrenderDetails.current[0]?.l3_approval))) && 
                                            <>
                                                <div className="bg-prime-20 d-flex justify-content-between align-items-center p-2 transition overflow-hidden mb-3">
                                                    <span className="fs-14px white-space-nowrap overflow-x-hidden fw-600 fs-16px" style={{ width: "95%", fontStyle: "normal" }} >Budget Surrender Approval</span>
                                                </div>
                                                <div className='col-md-12'>
                                                    <TextareaAutosize 
                                                    style={{width: '100%', padding: '10px'}} 
                                                    minRows={3} 
                                                    placeholder="Enter Remark Here" 
                                                    name="remark" 
                                                    onChange={(e) => {setApprovalFormdata(prev => ({...prev, remark: e.target.value}))}}
                                                    value={approvalFormdata.remark || ""}
                                                    />
                                                    <button className='navigation_button' style={{marginRight: '10px'}} type="button" onClick={() => handleClickOpen(0)}>Reject</button>
                                                    <button className='submit_button' type="button" 
                                                    onClick={() => handleClickOpen(1)}
                                                    >Approve</button>
                                                    
                                                </div>
                                            </>
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    // style={{backgroundColor: '#fff'}}
                >
                    <DialogTitle id="alert-dialog-title">
                    {"Are you sure?"}
                    </DialogTitle>
                    <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {approvalRef.current === 1
                            ? "Are you sure you want to approve this budget surrender request? Once approved, you won’t be able to change it."
                            : "Are you sure you want to reject this budget surrender request? Once rejected, you won’t be able to change it."}
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                    <Button className='navigation_button' onClick={() => setOpen(false)}>Cancel</Button>
                    <Button className='submit_button' onClick={() => handleApprovalAction(approvalRef.current)} autoFocus>
                        Yes
                    </Button>
                    </DialogActions>
                </Dialog>
                </>
        )
}